export const LIMIT_OPTIONS = [
  { label: "15", value: 15 },
  { label: "30", value: 30 },
  { label: "50", value: 50 },
  { label: "100", value: 100 },
]

export const MIN_SEARCH_LENGTH = 3